<!-- 选项卡-类型 -->
<template>
  <div class="tabs-type">
    <el-tabs v-model="activeIndex" type="card" @tab-click="tabToggle">
      <el-tab-pane v-for="(item, index) in navList" :key="index" :label="item.key" :name="item.val">
        <slot />
      </el-tab-pane>
    </el-tabs>
    <router-view />
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeIndex: '',
      navList: [
        {
          key: '参数范围',
          val: '0'
        },
        {
          key: '参数匹配',
          val: '1'
        }
      ]
    }
  },
  mounted() {
    this.activeIndex = this.index
  },
  methods: {
    tabToggle() {
      this.$emit('update:index', this.activeIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.tabs-type {
  /deep/ .el-tabs {
    .el-tabs__header {
      margin-bottom: 10px;
    }
    .el-tabs__content {
      padding: 0;
    }
  }
}
</style>
